<template>
	<div class="customer-list">
		<app-table
			class="table mt-5 is-not-selectable"
			name="customers"
			:current-page="currentPage"
			:last-page="lastPage"
			:items-total-quantity="itemsTotalQuantity"
			:items-quantity="itemsQuantity"
			:columns="columns"
			:rows="rows"
			@on-page="$emit('on-page', $event)"
			@on-search-event="onSearch"
		>
			<template slot="rows" slot-scope="props">
				<td v-show="showRow(columns, 1)" class="date is-not-selectable">{{ props.row.startDateFunctions | exactDate }} </td>
				<td v-show="showRow(columns, 2)" class="name">{{ props.row.name }} {{ props.row.lastname }}</td>
				<td v-show="showRow(columns, 3)" class="ruc">{{ props.row.ruc }}</td>
				<td v-show="showRow(columns, 4)" class="phone">{{ props.row.phone }}</td>
				<td v-show="showRow(columns, 5)" class="email">{{ props.row.email }}</td>
				<td v-show="showRow(columns, 6)" class="actions">
					<app-tooltip-button
						class="no-movil"
						color="success"
						icon="business"
						text="Ver Compañía"
						:width="iconWidth"
						@click-icon="goToCompanies(props.row)"
					/>
					<app-tooltip-button
						v-if="canEdit"
						class="no-movil"
						img="/static/img/actions-list/edit.svg"
						text="Editar Compañía"
						:width="iconWidth"
						@click-icon="edit(props.row)"
					/>
					<app-tooltip-button
						v-if="canDelete"
						class="no-movil"
						img="/static/img/actions-list/delete.svg"
						text="Eliminar Compañía"
						:width="iconWidth"
						@click-icon="$emit('delete-customer', props.row)"
					/>
					<div
						class="collapse-menu"
					>
						<v-menu>
							<v-btn dark icon slot="activator">
								<v-icon>more_horiz</v-icon>
							</v-btn>
							<v-list>
								<v-list-tile class="btn-menu-content">
									<v-list-tile-title class="menu-content" @click="goToCompanies(props.row)">
										<img
											icon="business"
											alt="icono"
											class="menu-option-icon"
											width="15px"
											height="15px"
										>
										<span class="ml-1 factory">Empresa</span>
									</v-list-tile-title>
								</v-list-tile>
								<v-list-tile v-if="canEdit" class="btn-menu-content">
									<v-list-tile-title class="menu-content" @click="edit(props.row)">
										<img
											src="/static/img/actions-list/edit.svg"
											alt="icono"
											class="menu-option-icon"
											width="15px"
											height="15px"
										>
										<span class="ml-1 edit">Editar</span>
									</v-list-tile-title>
								</v-list-tile>
								<v-list-tile v-if="canDelete">
									<v-list-tile-title class="menu-content" @click="$emit('delete-customer', props.row)">
										<img
											src="/static/img/actions-list/delete.svg"
											alt="icono"
											class="menu-option-icon"
											width="15px"
											height="15px"
										>
										<span class="ml-1">Eliminar</span>
									</v-list-tile-title>
								</v-list-tile>
							</v-list>
						</v-menu>
					</div>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import appTooltipButton from '@/components/shared/app-tooltip-button';

// Recurso ACL del módulo de clientes/empresas (coincide con la clave del mapa de permisos).
function permsResource() {
	return 'customers';
}

// ¿El usuario tiene permiso de editar / eliminar clientes?
function canEdit() {
	return this.$can(this.permsResource, 'update');
}

function canDelete() {
	return this.$can(this.permsResource, 'delete');
}

function edit({ id }) {
	this.goTo('customers-edit', { params: { id } });
}

function goToCompanies(company) {
	const { id, name, lastname } = company;
	const fullName = `${name}-${lastname}`;
	this.goTo('companies', { params: { customerId: id, customerName: fullName } });
	this.$setCurrentSubsidiary(company);
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function data() {
	return {
		actions: [
			{ icon: '/static/img/actions-list/factory.svg', title: 'Empresas' },
			{ icon: '/static/img/actions-list/edit.svg', title: 'Editar' },
			{ icon: '/static/img/actions-list/delete.svg', title: 'Eliminar' },
		],
		iconWidth: 25,
		showMenu: false,
	};
}

export default {
	name: 'customer-list',
	components: {
		appTooltipButton,
	},
	data,
	computed: {
		permsResource,
		canEdit,
		canDelete,
	},
	methods: {
		...mapActions('subsidiary', {
			$setCurrentSubsidiary: 'setCurrentSubsidiary',
		}),
		edit,
		goToCompanies,
		onSearch,
	},
	props: {
		columns: {
			type: Array,
			required: true,
		},
		itemsTotalQuantity: {
			type: Number,
			default: 1,
		},
		itemsQuantity: {
			type: Number,
			default: 1,
		},
		currentPage: {
			type: Number,
			default: 1,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
};
</script>
<style lang="scss" scoped>
	.customer-list {
		font-family: font(AvenirRegular) !important;
		font-size: size(small11) !important;
		padding-left: 48px;
		padding-right: 48px;
		@media (max-width: 768px) {
			padding-left: 10px;
			padding-right: 10px;
		}
	}
	.date {

		@media (max-width: 768px) {
			display: grid;
			grid-column: 1/2;
			grid-row: 2;
			white-space: nowrap;
		}
	}

	.name {

		@media (max-width: 768px) {
			display: grid;
			grid-column: 1/3;
			grid-row: 1;
			justify-content: flex-start;
			padding-left: 10px !important;
			text-align: center;
		}
	}

	.btn-menu-content {
		border-bottom: 1px solid color(grey-background-table);
	}

	.menu-content {
		align-items: center;
		color: color(red-icon);
		display: grid;
		font-family: font(AvenirRegular);
		font-size: size(small) !important;
		grid-column-gap: 3px;
		grid-template-columns: 15px 1fr;
		width: 175px;

		.factory {
			color: color(secondary);
		}

		.edit {
			color: color(btn-green);
		}
	}

	.collapse-menu {
		display: none;
		@media (max-width: 768px) {
			align-items: center;
			display: block;
			grid-column: 4/5;
			grid-row: 1;
			height: 100%;
			justify-content: center;

			.v-menu {
				align-items: center;
				display: flex;
				height: 100%;
				justify-content: center;

				.v-btn {
					background-color: color(btn-green);
					height: 25px;
					margin: 0;
					width: 25px;
				}
			}

		}
	}

	.ruc {

		@media (max-width: 768px) {
			display: grid;
			grid-column: 2/3;
			grid-row: 2;
		}
	}
	.name {
		@media (max-width: 768px) {
			display: grid;
			grid-row: 1;
			grid-column: 2/3;
			align-content: center;
		}
	}

	.phone {

		@media (max-width: 768px) {
			display: none;
			grid-column: 3/4;
			grid-row: 2;
		}
	}

	.email {

		@media (max-width: 768px) {
			display: grid;
			grid-column: 3/5;
			grid-row: 2;
		}
	}

	.actions {

		@media (max-width: 768px) {
			background-color: color(grey-background);
			grid-column: 4/5;
			grid-row: 1;
		}
	}
	.btnActions {
		margin: 0;
		background-color:#33cfc7;
		height:20px;
		width:20px;
	}
	.btnClose {
		margin: 0;
		background-color: #f58a93;
		height:20px;
		width:20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/customers/customer-list.vue